import type { MagentoStockStatus } from "@jti/magento-types";

type StockVisibilityConfig = {
  displayOutOfStock: boolean;
  displayAvailableInStores: boolean;
};

export const isVisibleByStockStatus = (
  stockStatus: MagentoStockStatus | undefined,
  displaySettings: StockVisibilityConfig
): boolean => {
  if (!stockStatus) return false;

  const visibilityByStatus: Record<MagentoStockStatus, boolean> = {
    IN_STOCK: true,
    AVAILABLE_IN_STORES: displaySettings.displayAvailableInStores,
    OUT_OF_STOCK: displaySettings.displayOutOfStock,
  };

  return visibilityByStatus[stockStatus];
};
